export interface PrivateModeSettings {
  blurContactNames: boolean;
  blurContactPhotos: boolean;
  blurLastMessage: boolean;
  blurChatContent: boolean;
  hideTyping: boolean;
  hideRecording: boolean;
  privateStatusView: boolean;
  privateVoicePlay: boolean;
  disableReadReceipt: boolean;
  hideOnlineStatus: boolean;
  restoreDeletedMessages: boolean;
  showEditedWithOriginal: boolean;
}

export interface CustomizationSettings {
  notifyContactOnline: boolean;
  notifyContactTyping: boolean;
  freezeChatListOnNewMessage: boolean;
  customChatBackgroundUrl: string;
}

export interface ExtraButtonsSettings {
  likeButton: boolean;
  pinChatButton: boolean;
  startNewChat: boolean;
  markReadUnread: boolean;
  transcribeAudio: boolean;
  translateMessage: boolean;
  downloadStatus: boolean;
  quickReplyButtons: boolean;
  saveContact: boolean;
  chatInfoButton: boolean;
}

export interface WebhookSettings {
  enabled: boolean;
  outgoingUrl: string;
  incomingUrl: string;
  method: 'POST' | 'GET' | 'PUT' | 'DELETE';
  authToken: string;
  customHeadersJson: string;
}

export interface SmartReplySettings {
  enabled: boolean;
  ignoreGroups: boolean;
  ignoreNonContacts: boolean;
  ignoreSavedContacts: boolean;
}

export interface BroadcastSettings {
  defaultDelayMs: number;
  maxPerMinute: number;
}

export interface RasiTechModulesSettings {
  privateMode: PrivateModeSettings;
  customizations: CustomizationSettings;
  extraButtons: ExtraButtonsSettings;
  webhooks: WebhookSettings;
  smartReply: SmartReplySettings;
  broadcast: BroadcastSettings;
}

export const DEFAULT_PRIVATE_MODE: PrivateModeSettings = {
  blurContactNames: false,
  blurContactPhotos: false,
  blurLastMessage: false,
  blurChatContent: false,
  hideTyping: false,
  hideRecording: false,
  privateStatusView: false,
  privateVoicePlay: false,
  disableReadReceipt: false,
  hideOnlineStatus: false,
  restoreDeletedMessages: false,
  showEditedWithOriginal: false,
};

export const DEFAULT_CUSTOMIZATIONS: CustomizationSettings = {
  notifyContactOnline: false,
  notifyContactTyping: false,
  freezeChatListOnNewMessage: false,
  customChatBackgroundUrl: '',
};

export const DEFAULT_EXTRA_BUTTONS: ExtraButtonsSettings = {
  likeButton: false,
  pinChatButton: false,
  startNewChat: false,
  markReadUnread: false,
  transcribeAudio: false,
  translateMessage: false,
  downloadStatus: false,
  quickReplyButtons: false,
  saveContact: false,
  chatInfoButton: false,
};

export const DEFAULT_WEBHOOK_SETTINGS: WebhookSettings = {
  enabled: false,
  outgoingUrl: '',
  incomingUrl: '',
  method: 'POST',
  authToken: '',
  customHeadersJson: '{}',
};

export const DEFAULT_SMART_REPLY_SETTINGS: SmartReplySettings = {
  enabled: false,
  ignoreGroups: true,
  ignoreNonContacts: false,
  ignoreSavedContacts: false,
};

export const DEFAULT_BROADCAST_SETTINGS: BroadcastSettings = {
  defaultDelayMs: 3000,
  maxPerMinute: 15,
};

export const DEFAULT_RASITECH_MODULES: RasiTechModulesSettings = {
  privateMode: DEFAULT_PRIVATE_MODE,
  customizations: DEFAULT_CUSTOMIZATIONS,
  extraButtons: DEFAULT_EXTRA_BUTTONS,
  webhooks: DEFAULT_WEBHOOK_SETTINGS,
  smartReply: DEFAULT_SMART_REPLY_SETTINGS,
  broadcast: DEFAULT_BROADCAST_SETTINGS,
};
